import actions from '@/core/store/item-ata/realinhamento/historico/actions'
import state from '@/core/store/item-ata/realinhamento/historico/state'
import mutations from '@/core/store/item-ata/realinhamento/historico/mutations'

export default { actions, state, mutations }
